import { decimalToPoundsAndPence } from '@tgg/util';

import { useAppConfigContext } from '../../../contexts';
import { palette } from '../../../theme';
import { Heading } from '../../Heading';
import { PaymentItemList } from '../../Payments/PaymentTile/PaymentItemList';
import { Tile } from '../../Tile';

import {
    StyledHeading,
    StyledBody,
    StyledTotalCostWrapper,
    StyledTotalCostText,
    StyledGymBagTileFooter,
    StyledPromoCode,
    StyledPromoCodeText,
    StyledDealsIcon,
} from './GymBagTile.styled';
import { GymBagTileProperties } from './GymBagTile.types';

export const GymBagTile = ({
    title,
    items,
    total,
    promoCode,
    isPromoCodeExpired,
}: GymBagTileProperties) => {
    const showPaymentItems = items.length > 0;

    const {
        appConfig: { appIdentifier },
    } = useAppConfigContext();

    return (
        <Tile gutterBottom={false} variant="borderBlue">
            <StyledHeading>
                <Heading
                    color={palette.common.white}
                    variant="h4"
                    gutterBottom={false}
                >
                    {title}
                </Heading>
            </StyledHeading>
            <StyledBody>
                {showPaymentItems && (
                    <PaymentItemList
                        items={items}
                        title={title}
                        hasSavingsItem={appIdentifier === 'commerce'}
                        isInGymBag={true}
                    />
                )}
            </StyledBody>
            {!!total && (
                <StyledGymBagTileFooter>
                    <StyledTotalCostWrapper>
                        <StyledTotalCostText>
                            payment due today
                        </StyledTotalCostText>
                        <StyledTotalCostText data-testid={`${title} total`}>
                            {decimalToPoundsAndPence(total)}
                        </StyledTotalCostText>
                    </StyledTotalCostWrapper>
                    {promoCode && (
                        <StyledPromoCode>
                            {promoCode && !isPromoCodeExpired && (
                                <StyledDealsIcon
                                    name="deals"
                                    size={[14, 16]}
                                    color={palette.common.blue}
                                />
                            )}
                            <StyledPromoCodeText data-testid="promo-code-text">
                                {isPromoCodeExpired
                                    ? `‘${promoCode}’ promo code expired`
                                    : `‘${promoCode}’ promo code applied`}
                            </StyledPromoCodeText>
                        </StyledPromoCode>
                    )}
                </StyledGymBagTileFooter>
            )}
        </Tile>
    );
};
